import Cookie from "js-cookie";

if (window.rhf_popup_enabled == 1) {
  let visits = Cookie.get("rhf_popup");

  if (typeof visits == "undefined") visits = { counter: 0, visited_urls: [] };

  let current_url = window.location.href;

  var isAO = (val) => (val instanceof Array || val instanceof Object ? true : false);

  if (!isAO(visits)) visits = JSON.parse(visits);

  let dismissed = Cookie.get("rhf_popup_dismissed");
  //let dismissed = false;

  if (visits.counter != 0) {
    if (!visits.visited_urls.includes(current_url)) {
      visits.counter++;
      visits.visited_urls.push(current_url);
    }
  } else {

    if (dismissed != "yes") {
      if (window.matchMedia("(min-width: 768px)").matches)
        jQuery(".ticket-popup").fadeIn(600);
      else jQuery(".ticket-popup__trigger").fadeIn(300);
    }

    visits.counter = 1;
    visits.visited_urls.push(current_url);
  }

  Cookie.set("rhf_popup", JSON.stringify(visits));

  setTimeout(function() {
    if (dismissed != "yes" && visits.counter >= window.rhf_popup_pages_count) {
      if (window.matchMedia("(min-width: 768px)").matches)
        jQuery(".ticket-popup").fadeIn(600);
      else jQuery(".ticket-popup__trigger").fadeIn(300);
    }
  }, 10 * 100);

  jQuery(document).on("gform_confirmation_loaded", function(event, formId) {
    if (formId != rhf_popup_form_id) return;

    jQuery(".ticket-popup__caption").hide();
    jQuery(".ticket-popup__holder").css("align-items", "center");
    jQuery(".ticket-popup__content").css("height", "auto");

    Cookie.set("rhf_popup_dismissed", "yes");

    setTimeout(function() {
      jQuery(".ticket-popup").fadeOut(800);
    }, 4000);
  });

  jQuery(document).on("click", ".ticket-popup__close", function(e) {
    jQuery(".ticket-popup").fadeOut();
    jQuery(".ticket-popup__lightbox").fadeOut();

    if (!jQuery(this).hasClass("ticket-popup-initial")) {
      Cookie.set("rhf_popup_dismissed", "yes");
    }
    
  });

  jQuery(document).on("click", ".ticket-popup__lightbox", function(e) {
    jQuery(".ticket-popup").fadeOut();
    jQuery(".ticket-popup__lightbox").fadeOut();

    if (!jQuery(this).hasClass("ticket-popup-initial")) {
      Cookie.set("rhf_popup_dismissed", "yes");
    }
  });

  jQuery(document).on("click", ".ticket-popup__trigger__close", function(e) {
    e.stopPropagation();

    jQuery(".ticket-popup__trigger").fadeOut();

    if (!jQuery(this).hasClass("ticket-popup-initial")) {
      Cookie.set("rhf_popup_dismissed", "yes");
    }
  });

  jQuery(document).on("click", ".ticket-popup__trigger", function(e) {
    jQuery(".ticket-popup__trigger").fadeOut();
    jQuery(".ticket-popup").fadeIn(600);
    jQuery(".ticket-popup__lightbox").fadeIn(600);
  });
}
